// extracted by mini-css-extract-plugin
export default {"layout":"d05d9f8425 _1e950cea6a _0b18bfe02e","h_slide":"_6a3584e5de","category":"_6e4d7295f5 _811a6843f7 _3b07d0fd77"};